<div class="card">
  <div class="card-body" #chartContainer>
    <div class="text-black text-bold" i18n>Overall Average for past 12 months</div>

    <div [class.d-none]="!isLoading && isDatasetEmpty()">
      <div class="graph">
        <canvas #ctx></canvas>
      </div>
      <ng-container #tooltipContainer></ng-container>
    </div>
    <app-loading-section *ngIf="isLoading"></app-loading-section>
    <app-empty-table *ngIf="!isLoading && isDatasetEmpty()">
      <img src="/assets/images/empty_icons/overall-rating.svg" alt="" />
      <h6 i18n>No Reviews Yet</h6>
      <p i18n>
        You haven’t received any guest or host reviews yet. Once reviews come in, you’ll be able to view, respond, and
        track your ratings here.
      </p>
    </app-empty-table>
  </div>
  <div class="card-footer d-flex p-0">
    <div class="d-flex flex-column align-items-center p-3 border-right">
      <div class="text-xl text-bold">{{ globalRating | number : '0.1-2' }}</div>
      <div class="text-muted text-uppercase text-xs" i18n>out of 5</div>
    </div>
    <div class="p-3 d-flex flex-column justify-content-center">
      <div class="text-semi-bold">
        <span i18n> 5-star rating</span> •
        <span class="text-info"
          >{{ statsByYear[currentYear]?.count || 0 }} <ng-container i18n>reviews</ng-container></span
        >
      </div>
      <ng-container *ngIf="getCurrentYear5StarInc() as rate">
        <div *ngIf="rate > 0">
          <ng-container i18n>Increased by</ng-container>
          <span class="text-success">⬆ {{ rate | number : '0.1-2' }}%</span>
          <ng-container i18n>this year!</ng-container>
        </div>
        <div *ngIf="rate < 0">
          <ng-container i18n>Decreased by</ng-container>
          <span class="text-danger">⬇ {{ rate | number : '0.1-2' }}%</span> <ng-container i18n>this year!</ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
